import { h } from 'preact'

export const EmptyResults = () => (
  <div className='empty-results-container'>
    <div className='empty-results-message'>
      <div className='empty-results-title'>No results found </div>
      <div className='empty-results-description'> Sorry, that filter combination has no results.
        <br /> Please try different criteria. </div>
    </div>
  </div>
)
